/**
 * Дедупликация realtime session:updated — избегаем двойного применения
 * (оптимистичная мутация + ответ сервера + realtime дают моргание).
 */
const DEDUP_MS = 800;
const updatedByMutationAt = new Map<string, number>();

export function markSessionUpdatedByMutation(sessionId: string): void {
  updatedByMutationAt.set(sessionId, Date.now());
  if (updatedByMutationAt.size > 200) {
    const now = Date.now();
    for (const [id, t] of updatedByMutationAt.entries()) {
      if (now - t > DEDUP_MS) updatedByMutationAt.delete(id);
    }
  }
}

export function shouldSkipRealtimeSessionUpdate(sessionId: string): boolean {
  const t = updatedByMutationAt.get(sessionId);
  if (!t) return false;
  if (Date.now() - t > DEDUP_MS) {
    updatedByMutationAt.delete(sessionId);
    return false;
  }
  return true;
}
